module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"yezza_store_layouts":"Yezza Store Layouts","default_layout":"Default layout","view_layout":"view layout","instagram_layout":"Instagram layout"},"id":{"yezza_store_layouts":"Yezza Store Layouts","default_layout":"Default layout","view_layout":"lihat layout","instagram_layout":"Instagram layout"}}')
  delete Component.options._Ctor
}
